import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-up-right', 'CornerUpRight', [["path",{"d":"M19 10.027H9a4 4 0 0 0-4 4V19m9.22-14L19 10.027l-4.78 5.028","key":"svg-0"}]]);